import './modal.scss';

import { Modal, type ModalProps } from 'antd';
import classNames from 'classnames';
import type { JSX } from 'react';

interface IChildrenArguments {
  classes: {
    actions: string;
    form: string;
  };
}

interface IProps extends Omit<ModalProps, 'children' | 'footer' | 'onCancel'> {
  onClose: () => void;
  children?: ((props: IChildrenArguments) => JSX.Element) | React.ReactNode;
}

const CHILDREN_CLASS_NAMES: IChildrenArguments['classes'] = {
  actions: 'modal__actions',
  form: 'modal__form'
};

/**
 * Оболочка antd Modal: центрирование, закрытие по клику на оверлей, крестику и ESC.
 * Своего футера нет — кнопки действий кладутся в `children` с классом `classes.actions`,
 * чтобы модалка сама решала их порядок и состояние (loading, disabled).
 */
const CustomModal: React.FC<IProps> = ({
  children,
  className,
  onClose,
  ...props
}) => {
  return (
    <Modal
      centered
      mask={{ closable: true }}
      {...props}
      className={classNames('modal', className)}
      onCancel={onClose}
      footer={null}
    >
      {typeof children === 'function'
        ? children({ classes: CHILDREN_CLASS_NAMES })
        : children}
    </Modal>
  );
};

export default CustomModal;
